(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-inline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('search-placeholder-cycler')) {
    class SearchPlaceholderCycler extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        if (!this.input) return;

        let words = [];
        try {
          words = JSON.parse(this.getAttribute('data-terms') || '[]').filter(Boolean);
        } catch (error) {
          words = [];
        }

        if (words.length === 0) return;

        const reducedMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (words.length === 1 || reducedMotion) {
          this.input.setAttribute('placeholder', words[0]);
          return;
        }

        this.words = words;
        this.wordIndex = 0;
        this.charIndex = 0;
        this.deleting = false;
        this.typeSpeed = 85;
        this.deleteSpeed = 40;
        this.pauseAfterType = 1500;
        this.pauseAfterDelete = 350;

        this.tick = this.tick.bind(this);
        this.timer = setTimeout(this.tick, 500);
      }

      disconnectedCallback() {
        if (this.timer) clearTimeout(this.timer);
      }

      tick() {
        if (!this.input.isConnected) return;

        const word = this.words[this.wordIndex];

        if (!this.deleting) {
          this.charIndex += 1;
          this.input.setAttribute('placeholder', word.slice(0, this.charIndex));

          if (this.charIndex === word.length) {
            this.deleting = true;
            this.timer = setTimeout(this.tick, this.pauseAfterType);
            return;
          }

          this.timer = setTimeout(this.tick, this.typeSpeed);
        } else {
          this.charIndex -= 1;
          this.input.setAttribute('placeholder', word.slice(0, this.charIndex));

          if (this.charIndex === 0) {
            this.deleting = false;
            this.wordIndex = (this.wordIndex + 1) % this.words.length;
            this.timer = setTimeout(this.tick, this.pauseAfterDelete);
            return;
          }

          this.timer = setTimeout(this.tick, this.deleteSpeed);
        }
      }
    }

    customElements.define('search-placeholder-cycler', SearchPlaceholderCycler);
  }
  } catch(e) { console.error(e); }
})();

})();
